import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import Layout from "../components/layout/LandingPageLayout";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    id: 1,
    title: "Why AI Accounting is the Future",
    excerpt:
      "AI accountants automate bookkeeping, reduce errors, and save time, giving businesses smarter insights and financial clarity.",
  },
  {
    id: 2,
    title: "AI vs Traditional Accounting",
    excerpt:
      "Unlike manual accountants, AI-powered systems process data in real-time, ensuring compliance and faster decision-making.",
  },
  {
    id: 3,
    title: "How AI Improves Compliance",
    excerpt:
      "AI tools track filing deadlines, monitor regulations, and send alerts, reducing penalties and ensuring hassle-free compliance.",
  },
  {
    id: 4,
    title: "Smarter Financial Insights",
    excerpt:
      "AI doesn’t just record numbers — it analyzes them. Get balance sheets, cash flow, and predictive analytics instantly.",
  },
];

const Blog = () => {
  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Header */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            color: "primary.main",
            fontWeight: "bold",
            mb: 6,
          }}
        >
          AI Accountant Blog
        </Typography>

        {/* Blog Grid */}
        <Grid container spacing={4}>
          {blogPosts.map((post) => (
            <Grid item xs={12} sm={6} md={4} key={post.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", mb: 1, color: "primary.main" }}
                  >
                    {post.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {post.excerpt}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    sx={{ textTransform: "none", fontWeight: "bold" }}
                  >
                    Read More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* CTA Section */}
        <Box
          sx={{
            textAlign: "center",
            mt: 8,
            p: 4,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 3,
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
            Ready to experience the power of AI Accounting?
          </Typography>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            color="primary"
            size="large"
            sx={{ px: 4, py: 1.5, borderRadius: 2, textTransform: "none" }}
          >
            Get Started Today
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default Blog;
